import ModalGuestAccount from './ModalGuestAccount';

export default ModalGuestAccount;
